// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"GO-z","carouselContainer":"HO-z"};